import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
export async function getDesignForRecategorize(design_id) {
  const r = await axios.get(`${API}/recategorize/design/${design_id}`, { headers: h() });
  return r.data;
}
export async function recategorizeDesign(design_id, gender, use_case_tags) {
  const r = await axios.post(`${API}/recategorize/design/${design_id}`, { gender, use_case_tags }, { headers: h() });
  return r.data;
}
